/** Inputs for the Fe machine prediction model */
export const MACHINE_CONSUMPT_FORM_FIELDS = [
  {
    label: "Fe",
    name: "Fe",
  },
  {
    label: "Cr",
    name: "Cr",
  },
  {
    label: "Ni",
    name: "Ni",
  },
  {
    label: "Mo",
    name: "Mo",
  },
  {
    label: "Al",
    name: "Al",
  },
  {
    label: "Pb",
    name: "Pb",
  },
  {
    label: "Cu",
    name: "Cu",
  },
  {
    label: "Sn",
    name: "Sn",
  },
  {
    label: "Ti",
    name: "Ti",
  },
  {
    label: "Ag",
    name: "Ag",
  },
  {
    label: "Ca",
    name: "Ca",
  },
  {
    label: "Mg",
    name: "Mg",
  },
  {
    label: "P",
    name: "P",
  },
  {
    label: "Zn",
    name: "Zn",
  },
  {
    label: "Ba",
    name: "Ba",
  },
  {
    label: "B",
    name: "B",
  },
  {
    label: "Si",
    name: "Si",
  },
  {
    label: "Na",
    name: "Na",
  },
  {
    label: "V",
    name: "V",
  },
  {
    label: "Bkg",
    name: "Bkg",
  },
  {
    label: "K",
    name: "K",
  },
  {
    label: "Li",
    name: "Li",
  },
  {
    label: "Mn",
    name: "Mn",
  },
  {
    label: "% Comb",
    name: "Comb",
  },
  {
    label: "40 °C",
    name: "40C",
  },
  {
    label: "100 °C",
    name: "100C",
  },
  {
    label: "TAN",
    name: "TAN",
  },
  {
    label: "TBN",
    name: "TBN",
  },
  {
    label: "Agua",
    name: "H2O",
  },
  {
    label: "Oxidación",
    name: "oxidation",
  },
  {
    label: "Nitración",
    name: "nitration",
  },
  {
    label: "Sulfatación",
    name: "sulphation",
  },
  {
    label: "Glicol.1",
    name: "glycol1",
  },
  {
    label: "Hollín",
    name: "soot",
  },
  {
    label: "PQ",
    name: "PQ",
  },
  {
    label: "Agua %",
    name: "waterPercent",
  },
  {
    label: "Hr. Lubricante",
    name: "lubricantHr",
  },
  {
    label: "Proyección de días",
    name: "dayProjections",
  },
];

export const AVAILABLE_SERVICES = {
  SV1: "Registros de analisis de Laboratorio",
};

export const AVAILABLE_PROJECTION_MODELS = {
  OPT1: "Proyección de Fierro en maquina",
};
